/**
 * Builds the `$getAllIds()` JSONata binding for dataset method-control templates.
 * Fetches every row matching the current filter (via the shared control-action
 * prefetch) and maps it to its identifier — independent of the control's
 * selectionMode. Caches the in-flight fetch so multiple `$getAllIds()`
 * references in one resolve share a single request.
 */
import { buildCache } from './buildCache';

export type GetAllIdsFunction = () => Promise<unknown[]>;

export const createGetAllIdsFunction = (
  fetchAllRows: () => Promise<any[] | undefined>,
  dataKey: string
): GetAllIdsFunction => {
  let cache: Promise<unknown[]> | undefined;

  const getAllIds: GetAllIdsFunction = () => {
    if (!cache) {
      cache = buildCache(fetchAllRows, dataKey);
    }
    return cache;
  };

  return getAllIds;
};
